import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

const lineVar = {
  hidden: { y: "108%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.05, ease, delay: 0.12 * i } }),
};

// Masked line-by-line reveal; observer sits on the unclipped wrapper.
export const MaskLines = ({ lines, className = "", as = "h1", onLoad = false, delay = 0, testid }) => {
  const Tag = motion[as];
  const trigger = onLoad ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.15 } };
  return (
    <Tag className={className} initial="hidden" {...trigger} data-testid={testid}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span className="block will-change-transform" variants={lineVar} custom={i + delay}>
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const FadeUp = ({ children, className = "", delay = 0, y = 28, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Em = ({ children, className = "" }) => (
  <span className={`font-serif-i ${className}`}>{children}</span>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`font-mono-x flex items-center gap-3 text-[0.8rem] font-bold uppercase tracking-[0.2em] sm:text-sm ${className}`}>
    <span className="inline-block h-[2px] w-7 shrink-0 bg-current" aria-hidden="true" />
    <span>{children}</span>
  </p>
);
